import { render, staticRenderFns } from "./orderDetial.vue?vue&type=template&id=97d2b2fc&scoped=true"
import script from "./orderDetial.vue?vue&type=script&lang=js"
export * from "./orderDetial.vue?vue&type=script&lang=js"
import style0 from "./orderDetial.vue?vue&type=style&index=0&id=97d2b2fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d2b2fc",
  null
  
)

export default component.exports